import "./property-preview.scss";
import {PropertyStatus} from "../../../shared/types/property";

interface PropertyPreviewProps {
    id: number | null;
    name: string;
    bed: string;
    bath: string;
    area: number | null;
    street_address: string;
    county: string;
    state: string;
    country: string;
    price: number | null;
    status: PropertyStatus;
    property_images: string[];
}

function PropertyPreview({id, name, bed, bath, area, street_address, county, state, country, price, status, property_images}: PropertyPreviewProps) {
    return (
        <div className="card property-preview border-0">
            <div className="card-body p-0 position-relative">
                <img src={property_images[0]} alt={name} className="img-fluid property-image"/>
                <div className="property-info p-3">
                    <h5 className="card-title mb-1">{name}</h5>
                    <p className="card-text small mb-1">{street_address}, {county}, {state}, {country}</p>
                    <p className="card-text small">{bed} Bed | {bath} Bath | {area} SQ FT</p>
                    <p className="card-text fw-bold">$ {Math.floor(price ?? 0)}</p>
                </div>
                <div className="overlay">
                    <a className="btn view-property" href={`../property/${id}/details`}>View Property</a>
                </div>
                <div className={`status-badge ${status}`}>
                    {status.replace("_", " ").toUpperCase()}
                </div>
            </div>
        </div>
    );
}

export default PropertyPreview;